export default __webpack_public_path__ + "static/media/stepper2.ed673f0f.png";